import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const Products = () => {
    return (
        <div className="products-wrapper">
            <div className="d-none d-lg-block">
                <div className="header-products">
                    <div className="row">
                        <div className="col-4 col-xl-3">
                            <div className="title-product">مشخصات</div>
                        </div>
                        <div className="col-6 col-xl-7">
                            <div className="no-center title-product warranty-title xmr-6">گارانتی</div>
                        </div>
                        <div className="col-2">
                            <div className="title-product xmr-3">هزینه</div>
                        </div>
                    </div>
                </div>
                <div className="product-item">
                    <div className="row d-flex align-items-center">
                        <div className="col-4 col-xl-3">
                            <div className="no-center item info-product d-flex">
                                <div className="img"><img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                                </div>
                                <div className="text">
                                    <h3 className="name">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                                    <div className="color-product">
                                        <span className="color black"></span>
                                        <span className="name">مشکی</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-xl-7">
                            <div className="no-center item warranty"><span className="text">18 ماهه شرکتی</span></div>
                        </div>
                        <div className="col-2">
                            <div className="item price persian-number"><span className="text">۵۷,۳۴۸,۰۰۰ ت</span></div>
                        </div>
                    </div>
                </div>
                <div className="product-item">
                    <div className="row d-flex align-items-center">
                        <div className="col-4 col-xl-3">
                            <div className="item no-center info-product d-flex">
                                <div className="img"><img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                                </div>
                                <div className="text">
                                    <h3 className="name">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                                    <div className="color-product">
                                        <span className="color black"></span>
                                        <span className="name">مشکی</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-xl-7">
                            <div className="no-center item warranty"><span className="text">18 ماهه شرکتی</span></div>
                        </div>
                        <div className="col-2">
                            <div className="item price persian-number"><span className="text">۵۷,۳۴۸,۰۰۰ ت</span></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-block d-lg-none">
                <div className="products-responsive">
                    <div className="list-product position-relative xmt-4">
                        <div className="price-box position-absolute">
                            <span className="discount persian-number">2,800,000 ت</span>
                            <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                        </div>
                        <div className="title-product-responsive">
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="content-cart d-flex align-items-center">
                            <div className="img-product">
                                <img src="./assets/sample-image/1420-w320h320.png"
                                     alt="img" className="img-fluid"/>
                            </div>
                            <div className="info-product">
                                <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                                    <span className="text-color">مشکی</span>
                                </div>

                                <div className="text-info-product-responsive d-block d-lg-none">
                                    <div className="warranty-product xmb-1">
                                        <IconName name="feather-shield" className="icon"/>
                                        <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                                    </div>
                                    <div className="seller-name-responsive xmb-1">
                                        <IconName name="add_business" className="icon"/>
                                        <span className="text">کامپیوتر زرد </span>
                                    </div>
                                    <div className="send-product xmb-1">
                                        <IconName name="date" className="icon"/>
                                        <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="list-product position-relative xmt-4">
                        <div className="price-box position-absolute">
                            <span className="discount persian-number">2,800,000 ت</span>
                            <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                        </div>
                        <div className="title-product-responsive">
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="content-cart d-flex align-items-center">
                            <div className="img-product">
                                <img src="./assets/sample-image/1420-w320h320.png"
                                     alt="img" className="img-fluid"/>
                            </div>
                            <div className="info-product">
                                <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                                    <span className="text-color">مشکی</span>
                                </div>

                                <div className="text-info-product-responsive d-block d-lg-none">
                                    <div className="warranty-product xmb-1">
                                        <IconName name="feather-shield" className="icon"/>
                                        <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                                    </div>
                                    <div className="seller-name-responsive xmb-1">
                                        <IconName name="add_business" className="icon"/>
                                        <span className="text">کامپیوتر زرد </span>
                                    </div>
                                    <div className="send-product xmb-1">
                                        <IconName name="date" className="icon"/>
                                        <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="list-product position-relative xmt-4">
                        <div className="price-box position-absolute">
                            <span className="discount persian-number">2,800,000 ت</span>
                            <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                        </div>
                        <div className="title-product-responsive">
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="content-cart d-flex align-items-center">
                            <div className="img-product">
                                <img src="./assets/sample-image/1420-w320h320.png"
                                     alt="img" className="img-fluid"/>
                            </div>
                            <div className="info-product">
                                <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                                    <span className="text-color">مشکی</span>
                                </div>

                                <div className="text-info-product-responsive d-block d-lg-none">
                                    <div className="warranty-product xmb-1">
                                        <IconName name="feather-shield" className="icon"/>
                                        <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                                    </div>
                                    <div className="seller-name-responsive xmb-1">
                                        <IconName name="add_business" className="icon"/>
                                        <span className="text">کامپیوتر زرد </span>
                                    </div>
                                    <div className="send-product xmb-1">
                                        <IconName name="date" className="icon"/>
                                        <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Products;